module.exports = {
  src: __webpack_public_path__ + "assets/images/help-icon.9a2c975cc1b477da.svg",
  width: 20,
  height: 20,
  toString: function() { return __webpack_public_path__ + "assets/images/help-icon.9a2c975cc1b477da.svg"; }
};